<template>
  <el-dialog title="选择图片" :visible.sync="dialogVisible" :append-to-body="true" @close="close" width="1100px">
    <p class="tips" v-if="tipsWidth">建议分辨率为：{{ tipsWidth }} * {{ tipsHeight }}</p>
    <div class="images">
      <draggable class="draggable" v-model="list">
        <div class="img-container" title="点击裁剪" v-for="(item, index) in list" :key="index" @click="clipImage(item, index)">
          <img :src="item + '?imageView2/2/w/250|imageslim'" v-img-auto>
          <i class="el-icon-circle-close close" @click.stop="deleteItem(index)"></i>
        </div>
      </draggable>
      <el-upload
        ref="upload"
        :action="this.$store.state.baseurl+'/image'"
        :show-file-list="false"
        multiple
        name="image"
        accept="image/*"
        :headers="headers"
        :data="uploadData"
        :on-success="uploadSuccess"
        :before-upload="beforeUpload"
        :on-error="uploadError">
        <div class="upload-btn">
          <i class="el-icon-upload"></i>
        </div>
      </el-upload>
    </div>
    <el-tabs class="tabs" v-model="type1" type="border-card" @tab-click="tabClick">
      <el-tab-pane label="缩略图" name="thumb">
        <el-scrollbar style="width:100%;height:350px;">
          <div class="history">
            <div class="history-item" v-for="(item, index) in history['thumb'].list" :key="index" @click="pushItem(item)">
              <img :src="item + '?imageView2/2/w/250|imageslim'" v-img-auto>
            </div>
          </div>
        </el-scrollbar>
      </el-tab-pane>
      <el-tab-pane label="商品主图" name="product">
        <el-scrollbar style="width:100%;height:350px;">
          <div class="history">
            <div class="history-item" v-for="(item, index) in history['product'].list" :key="index" @click="pushItem(item)">
              <img :src="item + '?imageView2/2/w/250|imageslim'" v-img-auto>
            </div>
          </div>
        </el-scrollbar>
      </el-tab-pane>
      <el-tab-pane label="轮播图" name="swiper">
        <el-scrollbar style="width:100%;height:350px;">
          <div class="history">
            <div class="history-item" v-for="(item, index) in history['swiper'].list" :key="index" @click="pushItem(item)">
              <img :src="item + '?imageView2/2/w/250|imageslim'" v-img-auto>
            </div>
          </div>
        </el-scrollbar>
      </el-tab-pane>
      <el-tab-pane label="详情图" name="detail">
        <el-scrollbar style="width:100%;height:350px;">
          <div class="history">
            <div class="history-item" v-for="(item, index) in history['detail'].list" :key="index" @click="pushItem(item)">
              <img :src="item + '?imageView2/2/w/250|imageslim'" v-img-auto>
            </div>
          </div>
        </el-scrollbar>
      </el-tab-pane>
      <el-tab-pane label="其它" name="other">
        <el-scrollbar style="width:100%;height:350px;">
          <div class="history">
            <div class="history-item" v-for="(item, index) in history['other'].list" :key="index" @click="pushItem(item)">
              <img :src="item + '?imageView2/2/w/250|imageslim'" v-img-auto>
            </div>
          </div>
        </el-scrollbar>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer" class="dialog-footer">
      <el-button class="footer-button" type="primary" @click="change" icon="el-icon-check">确认选择</el-button>
    </span>
    <el-dialog title="裁剪图片" :visible.sync="dialogVisible2" :append-to-body="true" center width="1000px">
      <div class="btn-group">
        <el-button-group>
          <el-button size="mini" @click="fixedNumber([16, 9])">16:9</el-button>
          <el-button size="mini" @click="fixedNumber([9, 16])">9:16</el-button>
          <el-button size="mini" @click="fixedNumber([1, 1])">1:1</el-button>
          <el-button size="mini" @click="fixedNumber([4, 3])">4:3</el-button>
          <el-button size="mini" @click="fixedNumber()">不限比例</el-button>
        </el-button-group>
      </div>
      <div class="dialog-container">
        <div class="clip-container">
          <vueCropper
            ref="cropper"
            :img="image"
            :fixedBox="option.fixedBox"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :centerBox="option.centerBox"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :full="option.full"
            :infoTrue="option.infoTrue"
            :outputType="option.outputType"
            :outputSize="option.outputSize"
            @realTime="realTime">
          </vueCropper>
        </div>
      </div>
      <span slot="footer">
        <el-button class="footer-button" @click="dialogVisible2 = false">取消</el-button>
        <el-button class="footer-button" type="primary" icon="el-icon-check" @click="finish">裁剪图片</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { getToken } from '@/utils/auth'
import request from '@/utils/request'
import draggable from 'vuedraggable'
import VueCropper from 'vue-cropper'
export default {
  name: 'uploadimg',
  components: {
    draggable,
    VueCropper
  },
  props: {
    value: {
      type: [Array, String]
    },
    tipsWidth: {
      type: [String, Number],
      default: ''
    },
    tipsHeight: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      headers: {
        Authorization: getToken()
      },
      list: [],
      history: {},
      type1: 'other',
      type: 'other',
      limit: 30,
      action: 'pending',
      timer: null,
      image: '',
      index: 0,
      cropper: '',
      scale: [[1, 1], [1, 1], [16, 9], '', ''],
      // scale: [1 / 1, 1 / 1, 16 / 9, '', ''],
      types: ['thumb', 'product', 'swiper', 'detail', 'other'],
      option: {
        fixedBox: false,
        autoCrop: true,
        autoCropWidth: 400,
        autoCropHeight: 400,
        centerBox: true,
        fixed: true,
        fixedNumber: [16, 9],
        full: true,
        infoTrue: true,
        outputType: 'png',
        outputSize: 0.9
      },
      previews: {}
    }
  },
  computed: {
    uploadData () {
      return {
        dir: this.type
      }
    }
  },
  created () {
    let types = this.types
    let history = {}
    for (let i = 0; i < types.length; i++) {
      history[types[i]] = {
        list: [],
        init: false
      }
    }
    this.history = history
  },
  methods: {
    close () {
      this.action = 'close'
    },
    show (list, type, limit) {
      this.action = 'pending'
      this.dialogVisible = true
      this.type1 = type || 'other'
      this.type = type || 'other'
      if (list) {
        this.list = JSON.parse(JSON.stringify(list))
      } else {
        this.list = []
      }
      this.limit = limit || 30
      this.getHistory(this.type)
      return new Promise((resolve, reject) => {
        this.timer = setInterval(_ => {
          if (this.action === 'finised') {
            resolve(this.list)
            this.dialogVisible = false
            clearInterval(this.timer)
          }
          if (this.action === 'close') {
            reject(new Error())
            this.dialogVisible = false
            clearInterval(this.timer)
          }
        }, 50)
      })
    },
    change () {
      this.action = 'finised'
      this.$emit('change', this.list)
    },
    tabClick (e) {
      this.getHistory(e.name)
    },
    getHistory (type) {
      let history = this.history
      if (!history[type].init) {
        let sendData = {
          dir: type
        }
        request({
          url: 'history-images',
          method: 'get',
          params: sendData
        }).then(res => {
          history[type].list = res.data.list
          history[type].init = true
        })
      }
    },
    uploadSuccess (response, file, fileList) {
      this.$myLoading.hide()
      this.pushItem(response.data.image.url)
      this.history[this.type].list.splice(0, 0, response.data.image.url)
    },
    uploadError (e) {
      this.$myLoading.hide()
      this.$message.error('图片过大，上传失败!')
    },
    beforeUpload (file) {
      console.log(file)
      if (file.size > 1024 * 1024 * 2) {
        this.$alert('图片过大，请控制在2MB以内', '提示', {
          confirmButtonText: '确定'
        })
        return false
      }
      this.$myLoading.show('上传中')
    },
    uploadRequest (e) {
      console.log(e)
    },
    deleteItem (index) {
      this.list.splice(index, 1)
    },
    pushItem (src) {
      if (this.limit === 1) {
        this.list = [src]
      } else {
        this.list.push(src)
      }
    },
    realTime (data) {
      this.previews = data
    },
    finish () {
      this.$refs.cropper.getCropBlob(res => {
        var formdata1 = new FormData()
        formdata1.append('dir', this.type)
        formdata1.append('image', res, res.name)
        let config = {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
        request({
          url: '/image',
          method: 'post',
          data: formdata1,
          config
        }).then(res => {
          this.$myLoading.hide()
          this.list[this.index] = res.data.image.url
          this.history[this.type].list.splice(0, 0, res.data.image.url)
          this.dialogVisible2 = false
        })
      })
    },
    fixedNumber (fix) {
      if (fix) {
        this.option.fixed = true
        this.option.fixedNumber = fix
      } else {
        this.option.fixed = false
      }
      this.$nextTick(_ => {
        this.$refs.cropper.goAutoCrop()
      })
    },
    clipImage (image, index) {
      this.index = index
      this.image = image
      this.dialogVisible2 = true
    },
    handleCrop () {
      this.$myLoading.show('加载图片中')
      this.cropper.getCroppedCanvas().toBlob(res => {
        var formdata1 = new FormData()
        formdata1.append('dir', this.type)
        formdata1.append('image', res, res.name)
        let config = {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
        request({
          url: '/image',
          method: 'post',
          data: formdata1,
          config
        }).then(res => {
          this.$myLoading.hide()
          this.list[this.index] = res.data.image.url
          this.history[this.type].list.splice(0, 0, res.data.image.url)
          this.dialogVisible2 = false
        })
      }, 'image/jpeg')
    }
  }
}
</script>
<style lang="less" scoped>
.tips {
  margin-bottom: 10px;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.images {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .draggable {
    display: flex;
    flex-wrap: wrap;
  }
  .img-container {
    height: 100px;
    width: 100px;
    padding: 5px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #dddee1;
    margin-right: 15px;
    margin-bottom: 15px;
    position: relative;
    cursor: pointer;
    img {
      height: 100%;
      width: 100%;
    }
    .close {
      position: absolute;
      top: -10px;
      right: -10px;
      background-color: #ffffff;
      font-size: 22px;
      overflow: hidden;
      border-radius: 50%;
      cursor: pointer;
    }
  }
  .upload-btn {
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    box-sizing: border-box;
    border: 1px dashed #a0a0a0;
    border-radius: 5px;
    font-size: 25px;
    margin-bottom: 15px;
    color: #666;
  }
}
.tabs {
  margin-top: 10px;
  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .history {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .history-item {
      width: 87px;
      height: 87px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 15px;
      margin-bottom: 15px;
      cursor: pointer;
      overflow: hidden;
      box-sizing: border-box;
      border: 2px solid #fff;
      img {
        transition: transform 0.3s;
      }
      &:hover {
        border: 2px solid #409EFF;
        img {
          transform: scale(1.2, 1.2);
        }
      }
    }
  }
}
.btn-group {
  width: 900px;
  margin: 0 auto;
  margin-bottom: 10px;
}
.dialog-container {
  width: 900px;
  margin: 0 auto;
  .clip-container {
    width: 900px;
    height: 500px;
    margin: 0 auto;
    border: 1px solid #ccc;
    position: relative;
    img {
      height: 100%;
      margin: 0 auto;
      width: auto;
    }
  }
}
.footer-button {
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadImg/index.vue